module.exports = __webpack_public_path__ + "static/media/deliverybox-icon.20a85167.svg";